import { motion } from "framer-motion";
import { Quotes } from "@phosphor-icons/react";
import { useTestimonials } from "../../lib/api";

export const Testimonials = () => {
  const { data: testimonials = [] } = useTestimonials();

  return (
    <section data-testid="testimonials-section" className="bg-canvas py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <p className="overline-label mb-4">04 — Client Signal</p>
        <h2 className="font-heading font-medium text-3xl md:text-4xl tracking-tight text-ink mb-14 max-w-xl">
          Trusted by agencies, investors & communities.
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <motion.blockquote
              key={t.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              data-testid={`testimonial-${i}`}
              className={`p-8 border-line border-t md:border-t-0 ${i > 0 ? "md:border-l" : ""}`}
            >
              <Quotes size={26} className="text-blueprint mb-5" weight="fill" />
              <p className="text-[15px] text-ink leading-relaxed">"{t.quote}"</p>
              <footer className="mt-6">
                <p className="font-heading font-medium text-sm text-ink">{t.author}</p>
                <p className="font-mono-tech text-[11px] tracking-wider text-sub mt-1">
                  {t.role} · {t.org}
                </p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
